import * as React from 'react';
import { BagOfChips } from '@lifeomic/phc-web-toolkit/src/components/FilterContent';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { useHashParams } from '@lifeomic/phc-web-toolkit/src/hooks/useHashParams';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { Filter, SequenceType, Test } from '../types';
import { defineMessages, useIntl } from 'react-intl';
import { handleFilterRemove } from './utils';
import ActionsContainerOE from './ActionsContainerOE';
import DiagnosticReport = fhir.DiagnosticReport;
import { VariantSelection } from './useSelectedVariants';
import { SelectedShortVariant } from './types';
import { Filter as FilterIcon } from '@lifeomic/chromicons';
import { SelectedFilterOption } from '../../../../src/components/common/Genomics/SelectedFilterOptionsContext';

const messages = defineMessages({
  chipTooltipOriginName: {
    id: 'omicsExplorer.filterResultsManager.chipTooltipOriginName',
    defaultMessage: '{origin} / {title}',
  },
  filterLabel: {
    id: 'omicsExplorer.filterResultsManager.filterLabel',
    defaultMessage: 'Filters',
  },
});

const useStyles = makeStyles((theme: Theme) => ({
  filterRow: {
    width: '100%',
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

interface OEHeaderProps {
  selectedFilterOptions: SelectedFilterOption[];
  setSelectedFilterOptions: any;
  isVariantSelectionEnabled: boolean;
  isMTBNotesEnabled: boolean;
  isFilterSmallDisplayEnabled: boolean;
  selectDiagnosticReport: (report: DiagnosticReport) => Promise<string[]>;
  variantSelection: VariantSelection;
  createTargetedVariant: (variant: SelectedShortVariant) => Promise<string>;
  selectedVariantError: boolean;
  activeTest: Test;
  selectedSequenceType: SequenceType;
}

export const OEHeader: React.FC<OEHeaderProps> = props => {
  const { formatMessage } = useIntl();
  const classes = useStyles({});
  const [, onHashParamPush] = useHashParams();

  return (
    <Box fullWidth flexWrap>
      {props.isVariantSelectionEnabled && <ActionsContainerOE {...props} />}
      <BagOfChips
        className={!props.isFilterSmallDisplayEnabled ? classes.filterRow : ''}
        smallDisplay={
          props.isFilterSmallDisplayEnabled
            ? {
                icon: FilterIcon,
                label: formatMessage(messages.filterLabel),
              }
            : undefined
        }
        options={props.selectedFilterOptions}
        onChipDelete={option =>
          handleFilterRemove({
            onHashParamPush,
            option,
            selectedFilterOptions: props.selectedFilterOptions,
            setSelectedFilterOptions: props.setSelectedFilterOptions,
          })
        }
        chipLabel={filter => {
          return filter.friendlyName || filter.searchValue;
        }}
        tooltipTitle={(filter: Filter) =>
          formatMessage(messages.chipTooltipOriginName, {
            origin: filter.origin,
            title:
              filter.tooltipTitle || filter.friendlyName || filter.searchValue,
          })
        }
      />
    </Box>
  );
};
